<template>
  <div>
    <div class="mt-3 mb-3">
      <div class="display-4 font-3xl text-left">Sample type</div>
    </div>

    <div v-if="sampleTypes.models.length">
      <b-row class="pr-3">
        <schedule-select-button
          v-for="(sampleType, index) in sampleTypes.models"
          :key="index"
          :item="sampleType"
          :isActive="selected_sample_type_id === sampleType.id"
          :label="sampleType.name"
          icon="cube"
          @onClick="onClick"
        ></schedule-select-button>
      </b-row>
    </div>
  </div>
</template>

<script>
import SampleTypeCollection from "@/collections/lab/SampleTypeCollection";
import ScheduleSelectButton from "./ScheduleSelectButton";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "SampleTypeSelector",

  components: { ScheduleSelectButton },

  props: {
    sampleTypes: {
      type: SampleTypeCollection,
      default: () => new SampleTypeCollection()
    }
  },

  computed: {
    ...mapGetters({ schedule_form: "scheduleForm" }),
    selected_sample_type_id() {
      return this.schedule_form.sample_type_id;
    }
  },

  methods: {
    ...mapActions(["UPDATE_SCHEDULE_FORM"]),

    onClick({ id }) {
      this.UPDATE_SCHEDULE_FORM({
        field: "sample_type_id",
        value: id
      });
    }
  }
};
</script>
